import { signOut } from 'next-auth/react';

interface StorageToken {
	accessToken: string;
	accessTokenExpires: string;
}

const minute = 1000 * 60;

const pendingRequests: Record<string, Promise<StorageToken>> = {};

export const acquireToken = async (scopes: string): Promise<string | undefined> => {
	const key = `TOKEN.${scopes}`;
	const value = localStorage.getItem(key);
	const storageToken: StorageToken = value ? JSON.parse(value) : null;

	if (
		!storageToken ||
		!storageToken.accessTokenExpires ||
		new Date(storageToken.accessTokenExpires).valueOf() - new Date().valueOf() <= minute
	) {
		try {
			if (!pendingRequests[key]) {
				pendingRequests[key] = fetch(
					`/api/auth/acquire-token/?scopes=${encodeURIComponent(scopes)}`,
				).then((r) => r.json());
			}
			const response: StorageToken = await pendingRequests[key];

			if (!response.accessToken) {
				throw new Error('Token error');
			}
			localStorage.setItem(key, JSON.stringify(response));

			return response.accessToken;
		} catch {
			await signOut();
		} finally {
			delete pendingRequests[key];
		}
	} else {
		return storageToken.accessToken;
	}
};
